import Box from "@mui/material/Box";
import { usePagesPage } from "modules/brands/context";
import ModuleDetailsDrawerContainer from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer";
import {
  PageModulesProvider,
  usePageModules,
} from "modules/brands/pages/ModulesContainer/components/PageModules/context";
import React, { FC } from "react";
import CollapsibleTable from "shared/components/CollapsibleTable";
import Filter from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import SearchField from "shared/components/SearchField";
import { scheduleColumns, renderModuleRow } from "./helpers";
import { useScheduleFilter } from "./hooks/useScheduleFilter";
import { groupModulesByMonth } from "./utils";

const SchedulePreviewContent: FC = () => {
  const { moduleDetailsDrawer } = usePageModules();
  const {
    isLoadingAllModules,
    allModulesList,
    onUpdateModuleStatus,
    data: pageList,
  } = usePagesPage();

  const { filtersData, filteredModules, searchValue, setSearchValue } =
    useScheduleFilter(allModulesList, pageList);

  const groupedModules = groupModulesByMonth(filteredModules);

  return (
    <FlexColumn marginTop="1rem">
      <FlexCenter
        marginBottom={"1rem"}
        gap="1rem"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        flexWrap="wrap"
      >
        <SearchField
          placeholder="Search..."
          value={searchValue}
          onChange={setSearchValue}
        />

        <Box display="flex" gap="1rem">
          {filtersData.map((filterProps) => (
            <Filter key={filterProps.title} {...filterProps} />
          ))}
        </Box>
      </FlexCenter>

      <CollapsibleTable
        columns={scheduleColumns}
        groups={groupedModules}
        renderRow={(module) =>
          renderModuleRow(
            module,
            moduleDetailsDrawer,
            onUpdateModuleStatus,
            pageList,
          )
        }
        noDataMessage="No Results Found"
        maxHeight="360px"
        isLoading={isLoadingAllModules}
      />

      <ModuleDetailsDrawerContainer />
    </FlexColumn>
  );
};

const SchedulePreview: FC = () => (
  <PageModulesProvider>
    <SchedulePreviewContent />
  </PageModulesProvider>
);

export default SchedulePreview;
